export const THUMBNAIL_PLACEHOLDER = "/placeholder.jpg";

export function getReliableThumbnailUrl(url?: string | null): string {
    if (!url) return THUMBNAIL_PLACEHOLDER;

    return url.replace(/(img\.youtube\.com\/vi\/[^/]+\/)maxresdefault\.jpg/i, "$1hqdefault.jpg");
}

export function handleThumbnailError(image: HTMLImageElement): void {
    const currentSrc = image.currentSrc || image.src;

    if (/img\.youtube\.com\/vi\/[^/]+\/hqdefault\.jpg/i.test(currentSrc)) {
        image.src = currentSrc.replace(/hqdefault\.jpg/i, "mqdefault.jpg");
        return;
    }

    if (/img\.youtube\.com\/vi\/[^/]+\/mqdefault\.jpg/i.test(currentSrc)) {
        image.src = currentSrc.replace(/mqdefault\.jpg/i, "default.jpg");
        return;
    }

    image.src = THUMBNAIL_PLACEHOLDER;
}
